import React from 'react';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';
import {
  APP_AGENTS_PATH,
  APP_DISPUTES_PATH,
  APP_POLICIES_PATH,
  APP_PROVIDERS_PATH,
  APP_REQUESTS_PATH,
  APP_SETTLEMENT_PATH,
  APP_TEMPLATES_PATH,
} from '../../routes';

const Page = styled.main`
  min-height: 100vh;
  background:
    radial-gradient(circle at top left, rgba(56, 189, 248, 0.12), transparent 30%),
    linear-gradient(180deg, #f8fafc 0%, #eef2ff 100%);
  color: #0f172a;
  padding: 1.5rem;
`;

const Shell = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  gap: 1.25rem;

  @media (min-width: 960px) {
    grid-template-columns: 240px minmax(0, 1fr);
    align-items: start;
  }
`;

const Sidebar = styled.aside`
  background: rgba(255, 255, 255, 0.86);
  border: 1px solid rgba(148, 163, 184, 0.24);
  border-radius: 24px;
  padding: 1rem;
  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.06);
`;

const Brand = styled.div`
  font-family: Georgia, 'Times New Roman', serif;
  font-size: 1.35rem;
  margin-bottom: 0.35rem;
`;

const SidebarText = styled.p`
  margin: 0 0 1rem;
  color: #475569;
  font-size: 0.92rem;
  line-height: 1.5;
`;

const Nav = styled.nav`
  display: grid;
  gap: 0.5rem;
`;

const NavItem = styled(NavLink)`
  text-decoration: none;
  color: #334155;
  font-weight: 600;
  padding: 0.75rem 0.9rem;
  border-radius: 14px;
  transition: all 0.2s ease;

  &.active {
    background: linear-gradient(135deg, #0ea5e9, #2563eb);
    color: #ffffff;
  }

  &:hover {
    background: rgba(37, 99, 235, 0.08);
  }
`;

const Content = styled.section`
  background: rgba(255, 255, 255, 0.86);
  border: 1px solid rgba(148, 163, 184, 0.24);
  border-radius: 28px;
  padding: 1.5rem;
  box-shadow: 0 20px 48px rgba(15, 23, 42, 0.06);
`;

const Eyebrow = styled.p`
  margin: 0 0 0.6rem;
  text-transform: uppercase;
  letter-spacing: 0.12em;
  font-size: 0.76rem;
  font-weight: 700;
  color: #0369a1;
`;

const Title = styled.h1`
  margin: 0;
  font-size: clamp(1.8rem, 4vw, 3rem);
  line-height: 1.05;
  font-family: Georgia, 'Times New Roman', serif;
`;

const Description = styled.p`
  margin: 1rem 0 0;
  max-width: 46rem;
  color: #475569;
  line-height: 1.7;
`;

const Body = styled.div`
  margin-top: 1.5rem;
`;

const navItems = [
  { to: APP_REQUESTS_PATH, label: 'Requests' },
  { to: APP_TEMPLATES_PATH, label: 'Templates' },
  { to: APP_AGENTS_PATH, label: 'Agents' },
  { to: APP_PROVIDERS_PATH, label: 'Providers' },
  { to: APP_SETTLEMENT_PATH, label: 'Settlement' },
  { to: APP_DISPUTES_PATH, label: 'Disputes' },
  { to: APP_POLICIES_PATH, label: 'Policies' },
];

const ControlPlaneLayout = ({ eyebrow, title, description, children }) => {
  return (
    <Page>
      <Shell>
        <Sidebar>
          <Brand>agent.market</Brand>
          <SidebarText>
            Requests-first control plane for drafting, routing, and settling answer markets.
          </SidebarText>
          <Nav>
            {navItems.map(item => (
              <NavItem key={item.to} to={item.to}>
                {item.label}
              </NavItem>
            ))}
          </Nav>
        </Sidebar>

        <Content>
          <Eyebrow>{eyebrow}</Eyebrow>
          <Title>{title}</Title>
          <Description>{description}</Description>
          <Body>{children}</Body>
        </Content>
      </Shell>
    </Page>
  );
};

export default ControlPlaneLayout;
